<template>
<div class="bash-wrap function-wrap">
                <div class="bash-box">
                    <p class="h1-title">{{indata.FirstTitle}}</p>
                    <p class="h2-title">{{indata.subTitle}}</p>
                     <ul class="function-nav-ul">
                        <li  :class="NowIndex==index?'active':''" @mouseenter="changeActive(index)"  v-for="(item,index) in indata.children" :key="index">
                            <p>{{item.characters}}</p>
                            <i></i>
                        </li>
                    </ul>

                  <ul class="function-list-ul ">
                        <li class="list-1" :class="NowIndex==index?'active':''"  v-for="(item,index) in indata.children" :key="index">
                            <p class="h3">{{item.title}}</p>
                            <p class="h4">{{item.introduce1}}</p>
                            <ol class="function-list-ol">
                              {{item.introduce2}}
                            </ol>
                         <img :src="item.showImage" alt="" />
                        </li>
                    </ul> 
                </div>
            </div>
</template>
<style scoped src="../../public/css/wmsBasis.css">
</style>

<script>
export default {
  name: "Templates24",
  props:{
    indata:Array
  },
  data(){
    return{
      NowIndex:0
    }
  }
  ,
  methods :{
changeActive(index){
  this.NowIndex=index
}
  }
};
</script>
